import { NgIf, UpperCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule, TranslationService } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';
import { LprExport } from '@lib/vehicle-intelligence/api/models/lpr-export.model';
import { LprExportStatus } from '@lib/vehicle-intelligence/models/alpr-export-status.enum';

@Component({
  selector: 'fs-lpr-export-status',
  templateUrl: './lpr-export-status.component.html',
  styleUrls: ['./lpr-export-status.component.scss'],
  standalone: true,
  imports: [MatChipsModule, UpperCasePipe, NgIf, SnIconModule, MatTooltipModule, TranslationModule],
})
export class LprExportStatusComponent {
  protected readonly LprExportStatus = LprExportStatus;
  constructor(private readonly _translateService: TranslationService) {}

  @Input()
  item: LprExport;

  get hasErrors(): boolean {
    return this.hasErrorsForItem(this.item);
  }

  get getErrors(): string {
    return this.getErrorsForItem(this.item);
  }

  hasErrorsForItem(item: LprExport): boolean {
    if (!item || !item.failedProviders) return false;

    return item.failedProviders.length > 0;
  }

  getErrorsForItem(item: LprExport): string {
    if (!item || !item.failedProviders || !Array.isArray(item.failedProviders)) {
      return '';
    }
    return item.failedProviders
      .map((x) => {
        return this._translateService.translate('alpr.export.errors.providerError', {
          provider: x,
        });
      })
      .join('\n\n');
  }

  hasProcessingStatus(item: LprExport) {
    return LprExportStatus.IN_PROGRESS === item.status || LprExportStatus.PENDING === item.status;
  }
}
